export const FRONT_ACLS_SUPERADMIN = {
	DASHBOARD: {
		KPI_COMPENSATED_EMISSIONS:
			'dashboard:front:kpi_compensated_emissions',
		KPI_TOTAL_COMPONSATION:
			'dashboard:front:kpi_total_compensation',
		KPI_FINANCING_OF_ADDITIONALITY:
			'dashboard:front:kpi_financing_of_additionality',
		REQUEST_CARBON_ASSESSMENT:
			'dashboard:front:request_carbon_assessment',
		FILTER_DATE: 'dashboard:front:filter_date',
		FILTER_COMPANIES: 'dashboard:front:filter_companies',
		FILTER_PROJECTS: 'dashboard:front:filter_projects',
		DONUTCHART: 'dashboard:front:donut_chart',
		LAST_OFFSETS_LIST:
			'dashboard:front:last_offsets_list',
		LAST_NEWS: 'dashboard:front:last_news',
	},
	OFFSETS: {
		FILTER: 'offsets:front:filter',
		FILTER_DATE: 'offsets:front:filter_date',
		FILTER_BRANDS: 'offsets:front:filter_brands',
	},
	BRANDS: {
		FILTER: 'brands:front:filter',
		FILTER_STATUS: 'brands:front:filter_status',
		FILTER_COUNTRIES: 'brands:front:filter_countries',
		FILTER_ORGANIZATIONS:
			'brands:front:filter_organizations',
	},
	PRODUCERS: {
		FILTER: 'producers:front:filter',
		FILTER_STATUS: 'producers:front:filter_status',
		FILTER_COUNTRIES: 'producers:front:filter_countries',
		FILTER_ORGANIZATIONS:
			'producers:front:filter_organizations',
	},
	PRODUCTIONS: {
		FILTER: 'productions:front:filter',
		FILTER_VERIFIED_STATUS:
			'productions:front:filter_verified_status',
		FILTER_MINTED_STATUS:
			'productions:front:filter_minted_status',
		FILTER_DATE: 'productions:front:filter_date',
		FILTER_PROJECTS: 'productions:front:filter_projects',
		FILTER_SITES: 'productions:front:filter_sites',
		FILTER_QUANTITY_ALERT:
			'productions:front:filter_quantity_alert',
	},
	MEASURABILITIES: {
		FILTER: 'measurabilities:front:filter',
		FILTER_STATUS: 'measurabilities:front:filter_status',
		FILTER_COUNTRIES:
			'measurabilities:front:filter_countries',
		FILTER_TECHNOLOGIES:
			'measurabilities:front:filter_technologies',
		FILTER_RANGE_PRICE_PER_TONE:
			'measurabilities:front:filter_range_price_per_tonne',
		FILTER_RANGE_AVAILABLE_STOCK:
			'measurabilities:front:filter_range_available_stock',
		TOGGLE_VIEW_MODE:
			'measurabilities:front:toggle_view_grid_list',
		EDIT_BUTTON: 'measurabilities:front:edit_button',
		STATUS_TAG: 'measurabilities:front:status_tag',
		TAB_GENERAL_INFORMATIONS:
			'measurabilities:front:tab_general_information',
		TAB_TRANSACTION_HISTORY:
			'measurabilities:front:tab_transaction_history',
		TAB_SITES: 'measurabilities:front:tab_sites',
	},
	ADDITIONALITIES: {
		FILTER: 'additionalities:front:filter',
		FILTER_STATUS: 'additionalities:front:filter_status',
		FILTER_COUNTRIES:
			'additionalities:front:filter_countries',
		FILTER_TECHNOLOGIES:
			'additionalities:front:filter_technologies',
		FILTER_RANGE_PART_FINANCED:
			'additionalities:front:filter_range_part_financed',
		TOGGLE_VIEW_MODE:
			'additionalities:front:toggle_view_grid_list',
		EDIT_BUTTON: 'additionalities:front:edit_button',
		STATUS_TAG: 'additionalities:front:status_tag',
		TAB_GENERAL_INFORMATIONS:
			'additionalities:front:tab_general_information',
		TAB_TRANSACTION_HISTORY:
			'additionalities:front:tab_transaction_history',
		TAB_SITES: 'additionalities:front:tab_sites',
	},
} as const;
